import { render, staticRenderFns } from "./toggle.vue?vue&type=template&id=312d1198&scoped=true&"
import script from "./toggle.vue?vue&type=script&lang=ts&"
export * from "./toggle.vue?vue&type=script&lang=ts&"
import style0 from "./toggle.vue?vue&type=style&index=0&id=312d1198&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312d1198",
  null
  
)

export default component.exports